const subscribeToUserActionResponse = (
    userActionResponse$,
    userActionsStore,
) =>
    userActionResponse$
        .subscribe(response => {
            // TODO api comes as array and proxy maps it to an object
            const watched = response[0]; // eslint-disable-line
            userActionsStore.actions.updateUserActions({ watched });
        });

export default subscribeToUserActionResponse;
